import { inject } from "@angular/core";
import { Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { Observable, EMPTY , take, of, mergeMap} from "rxjs";
import { LANDING_ROUTE } from "src/app/app-routing.module";
import { WspayConfirmation } from "@model";
import { WsPayService } from "@services";

export const WsPayStatusResolver: ResolveFn<WspayConfirmation | null> =
    (route: ActivatedRouteSnapshot,
     state: RouterStateSnapshot,
     router: Router = inject(Router),
     wsPayService: WsPayService = inject(WsPayService)
    ): Observable<WspayConfirmation | null> => {
        const token = route.queryParamMap.get('token');
        if (!token) {
            router.navigate([LANDING_ROUTE]);
            return EMPTY;
        }

        return wsPayService.fetchPaymentResult(token).pipe(
            take(1),
            mergeMap((res: WspayConfirmation | null) => {
                if (res) {
                    return of(res);
                } else {
                    router.navigate([LANDING_ROUTE]);
                    return EMPTY;
                }
            })
        );
    };